import { createStore } from 'zustand/vanilla'
import { useStore } from 'zustand'
import { FeatureFlagsStore } from '../types/state'

export const vanillaFeatureFlags = createStore<FeatureFlagsStore>((set, get) => ({
  featureFlags: [],
  isFeatureFlagActive: (key) => {
    const foundFlag = get().featureFlags?.find((flag) => flag.key === key)
    return foundFlag ? foundFlag.active : false
  },
  getFeatureFlag: (key) => {
    const foundFlag = get().featureFlags?.find((flag) => flag.key === key)
    return foundFlag ? foundFlag : undefined
  },
  setFeatureFlags: (featureFlags) => set((state) => ({ ...state, featureFlags }))
}))

export const useFeatureFlags = () => useStore(vanillaFeatureFlags)
